import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

export const horizonAssessPlugin = createFrontendPlugin({
  pluginId: 'horizon-assess-results',
  title: 'Assessment results',
  extensions: [
    PageBlueprint.make({
      name: 'evaluation',
      params: {
        path: '/assess/evaluations/:evaluationId',
        title: 'Assessment results',
        loader: () =>
          import('./AssessmentDetailsPage').then(m => (
            <m.AssessmentDetailsPage />
          )),
      },
    }),
    PageBlueprint.make({
      name: 'scope',
      params: {
        path: '/assess/scopes/:scopeId',
        title: 'Assessment scope',
        loader: () =>
          import('./AssessmentScopePage').then(m => <m.AssessmentScopePage />),
      },
    }),
  ],
});
